import { motion, AnimatePresence } from "framer-motion";
import { Navigation, Clock, Route as RouteIcon, ChevronDown, X } from "lucide-react";
import { GPS } from "@/constants/testIds";

// Top-center live navigation panel (extracted from GpsOverlay, Map Cleanup Stage 7).
export const NavPanel = ({ nav, navigateExternal, onChooseGps, clearRoute }) => (
  <AnimatePresence>
    {nav && (
      <motion.div
        data-testid={GPS.navPanel}
        initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }}
        className="absolute top-20 sm:top-24 left-2 right-2 sm:left-1/2 sm:right-auto sm:-translate-x-1/2 z-[1350] glass-strong rounded-2xl px-2.5 sm:px-4 py-2.5 sm:py-3 flex items-center gap-2 sm:gap-3 w-auto sm:w-[min(640px,calc(100vw-1rem))] max-w-[calc(100vw-1rem)]"
      >
        <div className="hidden sm:block bg-sky-500/20 rounded-xl p-2.5">
          <Navigation className="w-6 h-6 text-sky-400" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-heading font-bold text-sm sm:text-base leading-tight truncate">{nav.business.name}</p>
          <p className="text-slate-300 text-xs sm:text-sm truncate">{nav.first_instruction}</p>
        </div>
        <div className="flex items-center gap-2.5 sm:gap-3 pl-2 sm:pl-3 border-l border-slate-700/50 shrink-0">
          <div className="text-center">
            <p className="font-heading font-bold text-sky-400 text-base sm:text-lg leading-none">{nav.duration_min}<span className="text-xs ml-0.5">min</span></p>
            <p className="text-[10px] text-slate-400 uppercase tracking-wider flex items-center gap-1 justify-center mt-0.5"><Clock className="w-3 h-3" />ETA</p>
          </div>
          <div className="text-center">
            <p className="font-heading font-bold text-white text-base sm:text-lg leading-none">{nav.distance_miles}<span className="text-xs ml-0.5">mi</span></p>
            <p className="text-[10px] text-slate-400 uppercase tracking-wider flex items-center gap-1 justify-center mt-0.5"><RouteIcon className="w-3 h-3" />Dist</p>
          </div>
        </div>
        <div className="flex items-center gap-1 pl-2 border-l border-slate-700/50 shrink-0">
          <button
            data-testid="nav-external-btn"
            onClick={() => navigateExternal(nav.business)}
            className="h-10 px-2.5 sm:px-3 rounded-xl bg-sky-500 text-slate-900 font-heading font-bold text-sm flex items-center gap-1.5 hover:bg-sky-400"
            title="Open in your GPS app"
          >
            <Navigation className="w-4 h-4" /> <span className="hidden sm:inline">Navigate</span>
          </button>
          <button
            data-testid="nav-external-change"
            onClick={() => onChooseGps(nav.business)}
            className="hidden sm:flex w-8 h-10 rounded-xl hover:bg-slate-700/60 items-center justify-center text-slate-400"
            title="Choose GPS app"
          >
            <ChevronDown className="w-4 h-4" />
          </button>
        </div>
        <button data-testid={GPS.navPanelClose} onClick={clearRoute} title="End navigation" className="shrink-0 h-10 px-2.5 sm:px-3 rounded-xl bg-rose-500/20 border border-rose-400/40 text-rose-200 hover:bg-rose-500/30 flex items-center justify-center gap-1.5 font-heading font-bold text-sm transition-colors">
          <X className="w-5 h-5" /> <span className="hidden sm:inline">End</span>
        </button>
      </motion.div>
    )}
  </AnimatePresence>
);
